import { observer } from "mobx-react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { userStore } from "store/userStore";

type GuestGuardProps = {
  children: ReactNode;
};

const GuestGuard = observer(({ children }: GuestGuardProps) => {
  if (userStore.token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
});

export default GuestGuard;
